import React from "react";
import ApiIndicator from "../../../features/api-indicator/ApiIndicator";

interface LoadingIndicatorProps {
    isError?: boolean;
    error?: any;
    isLoading?: boolean;
    loaderType?: "circular" | "linear";
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
    isError = false,
    error = undefined,
    isLoading = true,
    loaderType = "circular",
}) => {
    return (
        <ApiIndicator
            isError={isError}
            error={error}
            isLoading={isLoading}
            isFetching={false}
            isUninitialized={false}
            isToastError={isError}
            loaderType={loaderType}
        />
    );
};
